// Direction of player text: its first letter decides; a right-to-left script gives 'rtl', any other letter 'ltr'.
// No letter gives undefined, so the element inherits the screen direction (dir="auto" would give 'ltr').
import { createElement } from 'react';

const RTL = /[\p{Script=Hebrew}\p{Script=Arabic}\p{Script=Syriac}\p{Script=Thaana}\p{Script=Nko}]/u;

export const textDir = text => {
  const letter = (text ?? '').match(/\p{L}/u)?.[0];
  return letter && (RTL.test(letter) ? 'rtl' : 'ltr');
};

// The direction of the page, for UI text inside player text.
export const screenDir = () => document.documentElement.dir || undefined;

// Inline player text, isolated from the text around it. With no letter it takes the direction of the screen,
// because a bare <bdi> is dir="auto", which gives 'ltr'.
export const Bdi = ({ children, ...props }) => createElement('bdi', { dir: textDir(children) ?? screenDir(), ...props }, children);
